import {FlutterBridge} from "@hybird/flutter/bridge/flutterBridge";
import {HybirdBridge} from "@hybird/core/bridge/hybirdBridge";
import {OhosBridge} from "@hybird/flutter/bridge/ohos/ohosBridge";

const flutterBridge = new FlutterBridge();
const ohosBridge = new OhosBridge();

class FlutterHybirdBridge extends HybirdBridge {
  ready(event) {
    flutterBridge.ready(event);
    ohosBridge.ready(event);
  }
}

function isSupport() {
  return ohosBridge.isSupport() || flutterBridge.isSupport();
}

/**
 * @type {HybirdBridge | FlutterCore | FlutterCamera | FlutterDeviceStorage | FlutterConsole | FlutterTest | FlutterFileIsolate | FlutterWX | FlutterLocation | FlutterWIFI | FlutterNetworkManage | FlutterXda | FlutterVersionManager | FlutterBluetooth| FlutterRequest| FlutterPreview | FlutterUsbDevice | FlutterMqtt | FlutterPdf | FlutterFingerprint | FlutterBluetoothPeripheral | FlutterSensors | FlutterVi5300 | FlutterGpio | FlutterSteppingMotor}
 */
const xda = new FlutterHybirdBridge();
const getBridge = () => {
  if (ohosBridge.isSupport()) {
    return ohosBridge;
  } else if (flutterBridge.isSupport()) {
    return flutterBridge;
  }

  return flutterBridge;
}

export {xda, flutterBridge, ohosBridge, getBridge, isSupport}
